import '@aws-amplify/ui-react/styles.css'

import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react'
import { Amplify } from 'aws-amplify'
import { Route, Routes } from 'react-router-dom'

import { awsConfig } from './awsConfig'
import { Mock } from './components'
import { AnnouncementProvider } from './providers/Announcement/Announcement.provider'
import { PatientCareTeamProvider } from './providers/CareTeam/PatientCareTeam.provider'
import { DrinkCounterProvider } from './providers/DrinkCounter/DrinkCounterProvider'
import { FeatureFlagProvider } from './providers/FeatureFlags/FeatureFlagProvider'
import { MessagesProvider } from './providers/Messages/Messages.provider'
import { MUMProvider } from './providers/MUM/MUMProvider'
import { useNavigation } from './providers/Navigation/Navigation.provider'
import { RequireAdmin } from './providers/Navigation/RequireAdmin.Wrapper'
import { RequireAuth } from './providers/Navigation/RequireAuth.Wrapper'
import { NotificationsProvider } from './providers/Notifications/NotificationsProvider'
import { OptionsProvider } from './providers/Options/Options.provider'
import { PassportProvider } from './providers/Passport/PassportProvider'
import { BACProvider } from './providers/PatientChartPage/BACProvider'
import { PatientChartPageProvider } from './providers/PatientChartPage/PatientChartPage.provider'
import { TrackingProvider } from './providers/PatientChartPage/TrackingProvider'
import { PatientsProvider } from './providers/Patients/Patients.provider'
import { PeerGroupsProvider } from './providers/PeerGroups/PeerGroups.provider'
import { ProviderDetailsProvider } from './providers/ProviderDetails/ProviderDetails.provider'
import { ProvidersProvider } from './providers/ProvidersProvider/ProvidersProvider.provider'
import { QuestionnaireProvider } from './providers/Questionnaire/Questionnaire.provider'
import { ResourcesProvider } from './providers/Resources/Resources.provider'
import { ScheduleProvider } from './providers/Schedule/Schedule.provider'
import { SubstanceCounterProvider } from './providers/SubstanceCounter/SubstanceCounter.Provider'
import { UserProvider } from './providers/User/User.provider'
import { WebSocketProvider } from './providers/WebSocket/WebSocketProvider'
import { Announcements } from './views/Admin/Announcements/Announcements.container'
import { PeerGroups } from './views/Admin/PeerGroups/PeerGroups.container'
import { ResourcesView } from './views/Admin/Resources/Resources.view'
import { Auth, Logout } from './views/Auth/Auth.container'
import { Main } from './views/Main/Main.container'
Amplify.configure(awsConfig)

// TODO ERROR AND LOADING STATES
export const App = () => {
  const { navigation } = useNavigation()

  const adminRoute = navigation?.allRoutes.find(
    (route) => route.route === 'admin'
  )

  return (
    <ThemeProvider>
      <Authenticator.Provider>
        <UserProvider>
          <WebSocketProvider
            url={`${process.env.REACT_APP_API_CONFIG_PATH}/ws`}
          >
            <FeatureFlagProvider>
              <MessagesProvider>
                <ScheduleProvider>
                  <PatientCareTeamProvider>
                    <ProviderDetailsProvider>
                      <PatientChartPageProvider>
                        <BACProvider>
                          <DrinkCounterProvider>
                            <MUMProvider>
                              <OptionsProvider>
                                <PatientsProvider>
                                  <PeerGroupsProvider>
                                    <NotificationsProvider>
                                      <ProvidersProvider>
                                        <ResourcesProvider>
                                          <AnnouncementProvider>
                                            <TrackingProvider>
                                              <SubstanceCounterProvider>
                                                <PassportProvider>
                                                  <QuestionnaireProvider>
                                                    <Routes>
                                                      <Route
                                                        path={'/'}
                                                        element={<Auth />}
                                                      ></Route>

                                                      <Route
                                                        path={'/logout'}
                                                        element={<Logout />}
                                                      ></Route>

                                                      {/* to avoid non-admin user access admin page by changing webpage url */}
                                                      <Route
                                                        path={'/peerGroups'}
                                                        element={
                                                          <RequireAuth>
                                                            <Main
                                                              usePaper={
                                                                adminRoute?.useViewPaper ??
                                                                true
                                                              }
                                                            >
                                                              <PeerGroups />
                                                            </Main>
                                                          </RequireAuth>
                                                        }
                                                        key='peerGroups'
                                                      ></Route>

                                                      {/* to avoid non-admin user access admin page by changing webpage url */}
                                                      <Route
                                                        path={'/announcements'}
                                                        element={
                                                          <RequireAuth>
                                                            <RequireAdmin>
                                                              <Main
                                                                usePaper={
                                                                  adminRoute?.useViewPaper ??
                                                                  true
                                                                }
                                                              >
                                                                <Announcements />
                                                              </Main>
                                                            </RequireAdmin>
                                                          </RequireAuth>
                                                        }
                                                        key='resources'
                                                      ></Route>

                                                      {/* to avoid non-admin user access admin page by changing webpage url */}
                                                      <Route
                                                        path={'/resources'}
                                                        element={
                                                          <RequireAuth>
                                                            <RequireAdmin>
                                                              <Main
                                                                usePaper={
                                                                  adminRoute?.useViewPaper ??
                                                                  true
                                                                }
                                                              >
                                                                <ResourcesView />
                                                              </Main>
                                                            </RequireAdmin>
                                                          </RequireAuth>
                                                        }
                                                        key='resources'
                                                      ></Route>

                                                      {navigation!.allRoutes
                                                        .filter(
                                                          (page) =>
                                                            !page.restricted
                                                        )
                                                        .map(
                                                          ({
                                                            route,
                                                            View,
                                                            useViewPaper,
                                                            Provider,
                                                          }) => (
                                                            <Route
                                                              path={`/${route}`}
                                                              element={
                                                                <RequireAuth>
                                                                  <Main
                                                                    usePaper={
                                                                      useViewPaper
                                                                    }
                                                                  >
                                                                    {View ? (
                                                                      Provider ? (
                                                                        <Provider>
                                                                          {View}
                                                                        </Provider>
                                                                      ) : (
                                                                        View
                                                                      )
                                                                    ) : (
                                                                      <Mock
                                                                        route={
                                                                          route
                                                                        }
                                                                      />
                                                                    )}
                                                                  </Main>
                                                                </RequireAuth>
                                                              }
                                                              key={route}
                                                            />
                                                          )
                                                        )}
                                                    </Routes>
                                                  </QuestionnaireProvider>
                                                </PassportProvider>
                                              </SubstanceCounterProvider>
                                            </TrackingProvider>
                                          </AnnouncementProvider>
                                        </ResourcesProvider>
                                      </ProvidersProvider>
                                    </NotificationsProvider>
                                  </PeerGroupsProvider>
                                </PatientsProvider>
                              </OptionsProvider>
                            </MUMProvider>
                          </DrinkCounterProvider>
                        </BACProvider>
                      </PatientChartPageProvider>
                    </ProviderDetailsProvider>
                  </PatientCareTeamProvider>
                </ScheduleProvider>
              </MessagesProvider>
            </FeatureFlagProvider>
          </WebSocketProvider>
        </UserProvider>
      </Authenticator.Provider>
    </ThemeProvider>
  )
}
